export const SubAbas = [
  { label: 'Entregas Fornecedores', rota: '/daf/logistica/fornecedor' },
];
